import { render } from "./DeleteSandboxes.vue?vue&type=template&id=7fe44a66"
import script from "./DeleteSandboxes.vue?vue&type=script&lang=js"
export * from "./DeleteSandboxes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__